module.exports = __webpack_public_path__ + "img/img (44).5cc80422.jpg";